import { Grid } from '@material-ui/core'
import { Fragment } from 'react'
import { useRecordContext } from 'react-admin'
import { HtmlTooltip } from '../../html_tooltip'
import Pill from '../../pill'

const PillField = (props) => {
  const record = useRecordContext(props)

  let label = ''
  let statusClass = ''

  let currentStatus = 'voted'
  if (record.votable && record.votes.length == 0) currentStatus = 'to_do'
  if (record.opened) currentStatus = 'in_progress'

  switch (currentStatus) {
    case 'voted':
      label = record.status == 'Pour' ? 'Adoptée' : 'Rejetée'
      statusClass = record.status === 'Pour' ? 'success' : 'error'
      break
    case 'in_progress':
      label = 'En cours de vote'
      statusClass = ''
      break
    case 'to_do':
      label = 'A voter'
      statusClass = 'warning'
      break
  }

  return <Pill id={record.id} value={label} status={statusClass} />
}

export const ResolutionStatus = (props) => {
  const record = props.record

  if (record.majorite_bo == 'sans vote')
    return (
      <Pill
        id={`majority${record.id}`}
        value={record.majorite_bo.toUpperCase()}
        status="light"
      />
    )

  return (
    <HtmlTooltip
      title={
        <Fragment>
          <Grid column spacing={2}>
            <Grid item>Pour : {record.tantiemes_pour}</Grid>
            <Grid item>Contre : {record.tantiemes_contre}</Grid>
            <Grid item>Abs. : {record.tantiemes_abstention}</Grid>
            <Grid item>Copro : {record.copro_tantiemes}</Grid>
          </Grid>
        </Fragment>
      }
    >
      <span>
        <PillField record={record} />
      </span>
    </HtmlTooltip>
  )
}
export default ResolutionStatus
